import { Coffee } from "lucide-react";

const B = process.env.REACT_APP_BACKEND_URL;

export const orgLogoSrc = (org) => {
  const id = org?.logoPhotoId;
  if (id) return `${B}/api/public/org-photos/${id}`;
  return org?.logoPhotoUrl ? `${B}${org.logoPhotoUrl}` : null;
};

export const OrgLogo = ({ src, size = "h-9 w-9", testid }) => (
  src
    ? <img src={src} alt="Logo organisasi" className={`${size} rounded-lg object-contain bg-white border border-slate-200 shrink-0`} data-testid={testid} />
    : <span className={`${size} rounded-lg bg-emerald-50 border border-emerald-100 grid place-items-center shrink-0`} data-testid={testid}><Coffee className="h-4 w-4 text-emerald-700" /></span>
);
